import { filter } from "ramda";
import { isNotNilOrEmpty } from "ramda-adjunct";

export { isNotNilOrEmpty } from "ramda-adjunct";

export const onlyValid = filter(isNotNilOrEmpty);

